import {useMemo} from "react";
import {PackagesItemByPerson, PackagesItemsPerson, PackagesItemsPersons} from "types/entities/PackagesItems";

export type SelectedPackageSummary = {
    karting: number;
    withoutKarting: number;
    all: number;
};

export const useSelectedPackageSummary = (
    selectedPackageItems?: PackagesItemByPerson[] | null,
    availablePackageItems?: PackagesItemsPersons | null
): SelectedPackageSummary => {
    return useMemo(() => {
        const selected = selectedPackageItems ?? [];
        const availableAdult: PackagesItemsPerson[] = availablePackageItems?.adult ?? [];
        const availableChild: PackagesItemsPerson[] = availablePackageItems?.child ?? [];

        const adultById = new Map<number, boolean>();
        for (const a of availableAdult) {
            if (a.id == null) continue;
            adultById.set(a.id, Boolean(a.karting));
        }

        const childById = new Map<number, boolean>();
        for (const c of availableChild) {
            if (c.id == null) continue;
            childById.set(c.id, Boolean(c.karting));
        }

        let karting = 0;
        let withoutKarting = 0;

        for (const s of selected) {
            if (s.id == null) continue;

            const qty = Number(s.quantity ?? 0);
            if (!Number.isFinite(qty) || qty <= 0) continue;

            const isAdult = (s.person_type as unknown as string) === "adult";
            const isChild = (s.person_type as unknown as string) === "child";

            if (!isAdult && !isChild) continue;

            const hasKarting = (isAdult ? adultById.get(s.id) : childById.get(s.id)) === true;

            if (hasKarting) karting += qty;
            else withoutKarting += qty;
        }

        return {karting, withoutKarting, all: karting + withoutKarting};
    }, [selectedPackageItems, availablePackageItems]);
};